if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-sticky-button]');
        this.priceEl = this.querySelector('[data-sticky-price]');
        this.ticking = false;
        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          window.requestAnimationFrame(() => {
            this.ticking = false;
            this.update();
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });

        // Dawn swaps the product info markup when the variant changes, so re-sync after each swap.
        this.unsubscribe = window.subscribe?.(PUB_SUB_EVENTS.variantChange, () => {
          window.requestAnimationFrame(() => this.observeTarget());
        });
        this.observeTarget();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        this.mutationObserver?.disconnect();
        this.unsubscribe?.();
        document.body.classList.remove('has-sticky-atc');
      }

      getTarget() {
        return document.getElementById(this.dataset.target);
      }

      observeTarget() {
        const target = this.getTarget();
        this.mutationObserver?.disconnect();
        if (!target) return;
        this.mutationObserver = new MutationObserver(() => this.sync());
        this.mutationObserver.observe(target, { attributes: true, childList: true, subtree: true });
        const price = document.getElementById(this.dataset.priceTarget);
        if (price) this.mutationObserver.observe(price, { childList: true, subtree: true, characterData: true });
        this.sync();
        this.update();
      }

      update() {
        const target = this.getTarget();
        const pastButton = Boolean(target) && target.getBoundingClientRect().bottom < 0;
        if (this.hidden === !pastButton) return;
        this.hidden = !pastButton;
        document.body.classList.toggle('has-sticky-atc', pastButton);
      }

      sync() {
        const target = this.getTarget();
        if (!target || !this.button) return;
        this.button.disabled = target.disabled;
        const label = target.querySelector('span');
        if (label) this.button.textContent = label.textContent.trim();

        const price = document.getElementById(this.dataset.priceTarget);
        const current = price?.querySelector('.price-item--sale, .price-item--regular');
        if (current && this.priceEl) this.priceEl.textContent = current.textContent.trim();
      }
    }
  );
}
